export function appDataReducerGitInfo(state, action) {
    const gitInfo = action.gitInfo.message;

    return gitInfo;
}
